import axios from "axios";
import { apiUrl } from "../lib/config";
import serializeParams from "./serializeParams";

const api = axios.create({
  baseURL: apiUrl,
  // Object params must go out as JSON — see serializeParams.
  paramsSerializer: { serialize: serializeParams },
});

export default api;
